import { render, staticRenderFns } from "./inventarization.vue?vue&type=template&id=1e2790c5&scoped=true"
import script from "./inventarization.vue?vue&type=script&lang=js"
export * from "./inventarization.vue?vue&type=script&lang=js"
import style0 from "./inventarization.vue?vue&type=style&index=0&id=1e2790c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2790c5",
  null
  
)

export default component.exports